import React from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import ProfilePostsContainer from './ProfilePostsContainer';
import ProfileHeader from './ProfileHeader';
import LoadingIcon from '../common/LoadingIcon';

/**
 * Publicly viewable profile page that doesn't require authentication.
 * Will redirect to public landing if 'like' or 'follow' is clicked without authentication.
 */
const ProfilePage = ({ notFound, initUserPage }) => {
  const { username } = useParams();
  const loading = useSelector(state => state.ui.loading.userLoading);

  useEffect(() => {
    initUserPage(username);
  }, [username, initUserPage]);

  // Early return pattern for loading/error states
  if (notFound) {
    return null;
  }

  if (loading) {
    return <LoadingIcon />;
  }

  return (
    <div>
      <div className="js-profile profile-container">
        <ProfileHeader username={username} />
        <ProfilePostsContainer username={username} />
      </div>
    </div>
  );
};

ProfilePage.propTypes = {
  notFound: PropTypes.bool.isRequired,
  initUserPage: PropTypes.func.isRequired,
};

export default ProfilePage;